import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './Components/Home';
import './App.css';
import theme from "./theme"
import { ThemeProvider } from '@emotion/react';
import Layout from './Components/Layout/Layout';
import { CssBaseline } from '@mui/material';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                    </Route>
                </Routes>
            </Router>
        </ThemeProvider>
    )
}

export default App;